var tokenkey = "w4ktvxnbpz7adgng24kchmzp";
var apipath = 'https://connectapi.nadia.com.my/digitaltransaction/';
import axios from 'axios'

const getDefaultState = () => {
    return {
        fundTransaction: [],
        prsFundTransaction: [],
        cartCount: 0,
    }
}

const state = getDefaultState()

// getters
// This will handle counts of the total buy/sell return summary amount for display
const getters = {
    cartPricing: (state, getters, rootState) => {
        return state.fundInvest.map(({ fundId, units, amounts }) => {
            const fund = rootState.fundDetails.all.find(fund => fund.fundId === fundId)
                return {
                  title: fund.Fund, 
                  nav: fund.NAV,
                  currency: fund.Currency,
                  navDate: fund.NAVDate,
                  units,
                  amounts
                }
        })
    },

    cartSA: (state, getters, rootState) => {
      return state.fundTransaction.map(({ fundId, units, amounts }) => {
          const fund = rootState.fundDetails.all.find(fund => fund.fundId === fundId)
              return {
                
                title: fund.Fund, 
                nav: fund.NAV,
                currency: fund.Currency,
                navDate: fund.NAVDate,
                units,
                amounts,
                recommendation
              }
      })
    },
    cartRedemption: (state, getters, rootState) => {
      return state.fundInvest.map(({ fundId, units, amounts }) => {
          const fund = rootState.fundDetails.all.find(fund => fund.fundId === fundId)
              return {
                  title: fund.Fund,
                  nav: fund.NAV,
                  currency: fund.Currency,
                  navDate: fund.NAVDate,
                  units,
                  amounts
              }
      })
    },
    cartSwitching: (state, getters, rootState) => {
      return state.fundInvest.map(({ fundId, units, amounts  }) => {
          const fund = rootState.fundDetails.all.find(fund => fund.fundId === fundId)
              return {
                title: fund.Fund,
                nav: fund.NAV,
                currency: fund.Currency,
                navDate: fund.NAVDate,
                units,
                amounts
              }
      })
  }
}

// actions
// This will handle what to be call whenever there's buy/sell into cart, or edit and remove.
const actions = {
    addProductToCart ({ state, commit }, product) {
        commit('setCheckoutStatus', null)
        if (product.inventory > 0) {
        const cartItem = state.items.find(item => item.id === product.id)
        if (!cartItem) {
            commit('pushProductToCart', { id: product.id })
        } else {
            commit('incrementItemQuantity', cartItem)
        }
        // remove 1 item from stock
        commit('products/decrementProductInventory', { id: product.id }, { root: true })
        }
    }
}

// mutations
// This will do the commit or uncommit to the state
const mutations = {
    pushProductToCart (state, { id }) {
      state.items.push({
        id,
        quantity: 1
      })
    },
  
    incrementItemQuantity (state, { id }) {
      const cartItem = state.items.find(item => item.id === id)
      cartItem.quantity++
    },
  
    setCartItems (state, { items }) {
      state.items = items
    },
  
    setCheckoutStatus (state, status) {
      state.checkoutStatus = status
    },
    Reset_Cart (state) {
      Object.assign(state, getDefaultState())
  },
  }

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}